import type {
  ShopAllStorefrontInput,
  ShopAllStorefrontProductCard,
} from "@/types/shopAll";

export interface Input extends ShopAllStorefrontInput {
  index: number;
}

export interface State {
  displayPosition: "above" | "below";
}

export default class ShopAllStorefront extends Marko.Component<Input, State> {
  onCreate() {
    this.state = { displayPosition: "above" };
  }

  getProductCardImgSrc(product: ShopAllStorefrontProductCard) {
    return (
      product.image ||
      `https://i.ebayimg.com/images/g/${product.zoom}/s-l640.jpg`
    );
  }

  measureStorefrontCard() {
    const el = this.getEl<HTMLDivElement>("storefront-card");
    if (el) {
      const windowHeight = window.innerHeight;
      const { top } = el.getBoundingClientRect();
      const offsetTop = el.offsetTop;
      const offsetBottom =
        (el?.offsetParent as HTMLDivElement).offsetHeight -
        el.offsetTop -
        el.offsetHeight;

      if (offsetTop < windowHeight / 2 - 300) {
        this.state.displayPosition = "below";
      } else if (offsetBottom < windowHeight / 2) {
        this.state.displayPosition = "above";
      } else if (top > windowHeight / 2) {
        this.state.displayPosition = "above";
      } else {
        this.state.displayPosition = "below";
      }
    }
  }
}
